import { Button } from "@/components/ui/button"
import { toast } from "sonner"
import { useCallback } from "react"
;

interface ProfileActionButtonsProps {
  onClose: () => void;
}

export function ProfileActionButtons({ onClose }: ProfileActionButtonsProps) {
  // Use useCallback to memoize handlers and prevent unnecessary rerenders
  const handleExport = useCallback(() => {
    try {
      // Export logic implementation would go here
      
      toast.success("Employee profile exported successfully");
    } catch {
      toast.error("Failed to export employee profile");
    }
  }, []);

  // Improved close handler that properly cleans up before closing
  const handleClose = useCallback(() => {
    try {
      // Directly invoke the passed onClose handler without setTimeout
      // setTimeout was causing issues with React's event system
      onClose();
    } catch {
      toast.error("There was an issue closing the profile");
      
      // Still attempt to close even if there's an error
      onClose();
    }
  }, [onClose]);

  return (
    <div className="flex justify-end gap-2 mt-6">
      {/* Use aria labels for better accessibility */}
      <Button 
        variant="outline" 
        onClick={handleClose}
        aria-label="Close profile"
      >
        Close
      </Button>
      <Button 
        onClick={handleExport}
        aria-label="Export profile"
      >
        Export Profile
      </Button>
    </div>
  )
}
